import React from "react";

interface ButtonProps {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary" | "danger";
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  variant = "primary",
}) => {
  const getButtonStyle = () => {
    switch (variant) {
      case "primary":
        return { backgroundColor: "#4a5568", color: "#fff" };
      case "secondary":
        return { backgroundColor: "#6c757d", color: "#fff" };
      case "danger":
        return { backgroundColor: "#dc3545", color: "#fff" };
      default:
        return {};
    }
  };

  return (
    <button
      onClick={onClick}
      style={{
        height: "40px",
        padding: "0 20px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        ...getButtonStyle(),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {label}
    </button>
  );
};

export default Button;
